import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { EtySubClient } from "../types/entities.interface";

export const useGetSubClients = (enabled: boolean) => {
    AuthHelper.presetPrivateRequest(api);

    const queryFn = async (): Promise<EtySubClient[]> => {
        const res = await api.get('/sub-clients/list');
        return res.data;
    };

    return useQuery({
        queryKey: ['sub-clients'],
        enabled,
        queryFn,
    });
};